import { ListItem, styled } from "@mui/material";

export const StyledListItem = styled(ListItem)`
  .MuiListItemButton-root:hover {
    background-color: #E1EDFB;
  }
`;
